import styled from 'styled-components';
import { colorWhite } from 'styleUtils';
export var BankCardListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7cjzdk-0"
})(["width:100%;margin:0 0 8px 0;&:last-child{margin-bottom:0;}"]);
export var OtherCardsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7cjzdk-1"
})(["display:", ";width:100%;margin:4px 0 0 0;"], function (_ref) {
  var isOpenOtherCards = _ref.isOpenOtherCards;
  return isOpenOtherCards ? 'block' : 'none';
});
export var ListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7cjzdk-2"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";padding:24px 16px 0 16px;&:not(:first-child){margin:4px 0 0 0;}"], colorWhite);
export var CompanyItem = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7cjzdk-3"
})([""]);
export var MoreCardsButton = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7cjzdk-4"
})(["width:100%;margin:1px 0 0 0;padding:16px 0;background-color:", ";text-align:center;"], colorWhite);